<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование доверенности') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <v-row>
          <v-col>
            <ValidationObserver ref="proxy">
              <user-proxy-info
                  v-if="isUserProxy"
                  ref="proxyInfo"
                  :proxy-info="currentProxy"
                  @keydown.native.enter="focusOnBtn('continueBtn')" />
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            ref="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import UserProxyInfo from '@/components/reused/proxies/UserProxyInfo.vue'
  import { DOCUMENT_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { PROXIES_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      UserProxyInfo,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            proxyId: null,
            proxyType: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(PROXIES_MANAGEMENT.NAMESPACE, {
        currentProxy: state => (state[PROXIES_MANAGEMENT.STATE.CURRENT_PROXY] || { })
      }),
      isUserProxy () {
        return this.dialogProp.proxyType === DOCUMENT_TYPES.USER_PROXY
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.dialogProp.proxyId) {
          vm.getProxyAdmin()
        }
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(PROXIES_MANAGEMENT.NAMESPACE, {
        getProxyAdminAction: PROXIES_MANAGEMENT.ACTIONS.GET_PROXY_ADMIN,
        updateProxyAction: PROXIES_MANAGEMENT.ACTIONS.UPDATE_PROXY,
        clearProxyAdminAction: PROXIES_MANAGEMENT.ACTIONS.CLEAR_PROXY_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearProxyAdminAction()
          ])
      },
      continueOperation: async function () {
        const result = await this.$refs.proxy.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          const proxy = await this.$refs.proxyInfo.getData()
          await this.updateProxyAction({
            proxyType: this.dialogProp.proxyType,
            proxyId: this.dialogProp.proxyId,
            proxy
          })
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getProxyAdmin: async function () {
        this.isLoading = true
        try {
          await this.getProxyAdminAction({
            proxyType: this.dialogProp.proxyType,
            proxyId: this.dialogProp.proxyId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
